import { listNotifications } from "@/features/notifications/notifications.api";
import type {
  ListNotificationsQuery,
  ListNotificationsResponse,
} from "@/features/notifications/schemas/notification.schema";
import { useListResource } from "@/shared/hooks/use-list-resource";

/// GET `/workspaces/:wsId/notifications`. The inbox page consumes this.
/// List policy lives in `useListResource`.
export function useNotifications(workspaceId: string | undefined, query: ListNotificationsQuery) {
  return useListResource<ListNotificationsResponse>({
    queryKey: ["notifications", workspaceId, query],
    workspaceId,
    fetch: (wsId) => listNotifications(wsId, query),
  });
}
